import React from "react";
import { useNavigate } from "react-router-dom";
import { LayoutDashboard, PawPrint, Receipt, CalendarDays, MoreHorizontal } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { canAccessDashboardPath } from "@/lib/routeHome";
import { useTranslation } from "react-i18next";

export default function BottomNav({ onOpenMore }) {
    const nav = useNavigate();
    const { user, can } = useAuth();
    const { t } = useTranslation();
    const primaryItems = [
        { label: t("nav.dashboard"), to: "/dashboard", icon: LayoutDashboard, permission: "view" },
        { label: t("groups.livestock"), to: "/livestock", icon: PawPrint, permission: "view" },
        { label: t("groups.sales"), to: "/sales", icon: Receipt, permission: "add" },
        { label: t("nav.calendar"), to: "/calendar", icon: CalendarDays, permission: "view" },
    ].filter((item) => canAccessDashboardPath(user, item.to) && can(item.permission));

    return (
        <nav aria-label={t("nav.primary_mobile")} className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#071f14] text-white border-t border-[#D6AA45]/20 p-1 shadow-[0_-8px_24px_rgba(5,25,16,0.18)]">
            <div className="max-w-[1000px] mx-auto px-2 flex items-center justify-between">
                {primaryItems.map(({ label, to, icon: Icon }) => (
                    <button key={to} aria-label={label} onClick={() => nav(to)} className="flex-1 p-2 text-center rounded-md hover:bg-white/10 focus-visible:ring-aj-gold">
                        <Icon className="w-6 h-6 mx-auto text-aj-gold" />
                        <div className="text-[10px] mt-0.5">{label}</div>
                    </button>
                ))}
                <button aria-label={t("nav.more")} data-testid="mobile-more-btn" onClick={onOpenMore} className="flex-1 p-2 text-center rounded-md hover:bg-white/10 focus-visible:ring-aj-gold">
                    <MoreHorizontal className="w-6 h-6 mx-auto" />
                    <div className="text-[10px] mt-0.5">{t("nav.more")}</div>
                </button>
            </div>
        </nav>
    );
}
